require('./bugsnag');
require('./bootstrap');

window.Vue = require('vue');


require('./polyfill');
require('./vue/plugins');
require('./vue/prototypes');
require('./vue/directive');
require('./vue/filters');
require('./vue/components');
window.moment = require('moment');


window.flash = function (type, message) {
    let flash = document.getElementById("flash");
    flash.classList.add("is-active");
    flash.classList.add(`is-${type}`);
    document.getElementById("flash-message").innerHTML = message;

    setTimeout(function () {
        flash.classList.remove("is-active");
        flash.classList.remove(`is-${type}`);
    }, 3000);
};